import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import * as styles from './FaqSectionList.module.scss'
import { SvgChevron, SvgClose } from '../ui/svg-icons'

function FaqSectionList({
  className,
  sections,
  onCategoryClick,
  activeSectionId,
  label,
  ...rest
}) {
  const [openState, setOpenState] = useState(false)

  const handleCollapsibleClick = () => {
    setOpenState(prevState => !prevState)
  }

  return (
    <div className={styles.sidebarWrapper}>
      <aside className={styles.sidebar}>
        <div
          className={classNames(
            styles.collapsibleSidebar,
            openState && styles.open
          )}
          aria-expanded={openState}
        >
          <button className={styles.btn} onClick={handleCollapsibleClick}>
            <span>{label}</span>
            {openState ? (
              <SvgClose width={20} height={20} />
            ) : (
              <SvgChevron className={styles.svg} />
            )}
          </button>
          <div className={styles.collapsibleSidebarBody}>
            <ul className={classNames(styles.sectionList, className)} {...rest}>
              {sections?.map(({ id, title }) => (
                <li key={id}>
                  <button
                    onClick={() => {
                      handleCollapsibleClick()
                      onCategoryClick(id)
                    }}
                    className={classNames(
                      styles.sectionItem,
                      activeSectionId === id && styles.active
                    )}
                  >
                    <span>{title}</span>

                    {activeSectionId === id && (
                      <SvgChevron className={styles.svg} />
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </aside>
    </div>
  )
}

FaqSectionList.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onCategoryClick: PropTypes.func,
  activeSectionId: PropTypes.string,
}

export default FaqSectionList
